import { render, staticRenderFns } from "./CheckTypeASelector.vue?vue&type=template&id=db5a5790&scoped=true"
import script from "./CheckTypeASelector.vue?vue&type=script&lang=js"
export * from "./CheckTypeASelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5a5790",
  null
  
)

export default component.exports